import {
    Modal,
    Menu,
    ToolbarIcon,
    InfoPanel,
} from '@instinet-analytics/semantic-ui-components';
import React, { useState } from 'react';
import { doNothing } from 'utils/general';
import { useSelectUserHasAuthority } from 'login/store/selectors';

import './EstimatedTradeCostComparisonDebugModal.scss';

import classNames from 'classnames';
import JsonPanel from 'utils/components/JsonPanel/JsonPanel';
import { useEstimatedTradeCostComparisonWidgetConfigSlice } from '../../store/configslice';
import { useEstimatedTradeCostComparisonWidgetComponentSlice } from '../../store/componentSlice';
import { useEstimatedTradeCostComparisonData } from '../../hooks';
import { initialEstimatedTradeCostComponentState } from '../../../widget/store/componentSlice';

export function EstimatedTradeCostComparisonDebugModal() {
    const enableSupport = useSelectUserHasAuthority(
        'indigo.enableIndigo2Support'
    );

    if (!enableSupport) {
        return <></>;
    }

    return (
        <div className="EstimatedTradeCostComparisonDebugModal">
            <Modal
                className="EstimatedTradeCostComparisonDebugModal_Modal"
                trigger={<ToolbarIcon name="bug" tooltip={'Debug'} />}
                headerText="Pre-Trade Cost Comparison Debug"
                onSave={doNothing}
                saveText="Close"
            >
                <EstimatedTradeCostComparisonDebugModalBody />
            </Modal>
        </div>
    );
}

function EstimatedTradeCostComparisonDebugModalBody() {
    const [view, setView] = useState('request');

    const { config } = useEstimatedTradeCostComparisonWidgetConfigSlice();
    return (
        <div className="EstimatedTradeCostComparisonDebugModalBody">
            <Menu pointing vertical>
                {config.optimizations.map((_r, i) => (
                    <MenuItem
                        key={'request' + i}
                        view={'request' + i}
                        text={'Request ' + (i + 1)}
                        onChangeView={() => setView('request' + i)}
                        activeView={view}
                    />
                ))}
                <MenuItem
                    view={'config'}
                    text={'Config'}
                    onChangeView={setView}
                    activeView={view}
                />
                <MenuItem
                    view={'component'}
                    text={'Component'}
                    onChangeView={setView}
                    activeView={view}
                />
            </Menu>
            <div className="EstimatedTradeCostComparisonDebugModalBodyContent">
                <EstimatedTradeCostComparisonDebugModalBodyContent
                    view={view}
                />
            </div>
        </div>
    );
}

function MenuItem(props: {
    activeView: string;
    view: string;
    text: string;
    className?: string;
    onChangeView: (nextView: string) => void;
}) {
    const { activeView, view, onChangeView, text, className } = props;
    const cssClasses = classNames('menu-' + view, className);
    return (
        <Menu.Item
            active={activeView === view}
            onClick={() => onChangeView(view)}
            className={cssClasses}
        >
            {text}
        </Menu.Item>
    );
}

function EstimatedTradeCostComparisonDebugModalBodyContent({
    view,
}: {
    view: string;
}) {
    const { config } = useEstimatedTradeCostComparisonWidgetConfigSlice();
    const { component } = useEstimatedTradeCostComparisonWidgetComponentSlice();
    const data = useEstimatedTradeCostComparisonData();

    switch (view) {
        case 'request0':
            return (
                <NullableJsonPanel
                    data={data?.requests[0]}
                    desc={'No request data found'}
                />
            );
        case 'request1':
            return (
                <NullableJsonPanel
                    data={data?.requests[1]}
                    desc={'No request data found'}
                />
            );
        case 'request2':
            return (
                <NullableJsonPanel
                    data={data?.requests[2]}
                    desc={'No request data found'}
                />
            );
        case 'request3':
            return (
                <NullableJsonPanel
                    data={data?.requests[3]}
                    desc={'No request data found'}
                />
            );
        case 'request4':
            return (
                <NullableJsonPanel
                    data={data?.requests[4]}
                    desc={'No request data found'}
                />
            );
        case 'request5':
            return (
                <NullableJsonPanel
                    data={data?.requests[5]}
                    desc={'No request data found'}
                />
            );

        case 'config':
            return (
                <NullableJsonPanel
                    data={config}
                    desc={'No config state saved'}
                />
            );
        case 'component':
            return (
                <NullableJsonPanel
                    data={
                        component === initialEstimatedTradeCostComponentState
                            ? undefined
                            : component
                    }
                    desc={'No component state saved'}
                />
            );
    }
    return <div>View: {view}</div>;
}

function NullableJsonPanel({ data, desc }: { data: unknown; desc: string }) {
    if (!data) {
        return <InfoPanel message={desc} />;
    }
    return <JsonPanel data={data} />;
}
